import React, { Component, useState, useEffect } from "react";
import {  View,  Text, Image, FlatList, TouchableOpacity,} from "react-native";
import UserDetails from "../SubComponents/Dashboard/UserDetails";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,maxSize,} from "rn-responsive-styles";
import Sidebar from "../common/Sidebar";
import Header from "../common/Header";
import TabHeader from "../common/TabHeader";
import MobileHeader from "../common/MobileHeader";
import ModalAlert from "../common/ModalAlert";
import { useLogin } from "../context/loginProvider";
import RootNavigation from "../utilities/RootNavigation";
import { Outlet, useLocation, useParams } from "react-router-dom"

export default function Profile(props) {
  const styles = useStyles();
  const location = useLocation();
  const deviceSize = useDeviceSize();
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [activeScreen, setActiveScreen] = useState("Customer Details");
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [showLogoutModal, setShowLogoutModal] =useState(false);

  const profileTabs = [
    {
      id: 1,
      name: "Customer Details",
      activeIcon: require("../assets/images/Customer_Details.png"),
      icon: require("../assets/images/Customer_Details_yellow.png"),
      width: 32,
      height: 28,
      route : ""
    },
    {
      id: 2,
      name: "Pool Account Details",
      activeIcon: require("../assets/images/Pool_Acc_Details.png"),
      icon: require("../assets/images/Pool_Acc_Details_yellow.png"),
      width: 32,
      height: 28,
      route : "PoolAccount"
    },
    {
      id: 3,
      name: "Fuel \nPayment",
      activeIcon: require("../assets/images/fuel_icon.png"),
      icon: require("../assets/images/fuel_icon_yellow.png"),
      width: 22,
      height: 25,
      route : "Fuel"
    },
    {
      id: 4,
      name: "Tag\nDetails",
      activeIcon: require("../assets/images/Pool_Account_Balance.png"),
      icon: require("../assets/images/Pool_Account_Balance_yellow.png"),
      width: 28.4,
      height: 28.4,
      route : "TagDetails"
    },
    {
      id: 5,
      name: "My\nVehicles",
      activeIcon: require("../assets/images/Registered_Vehicle.png"),
      icon: require("../assets/images/Registered_Vehicle.png"),
      width: 32,
      height: 28,
      route : "MyVehicles"
    },
  ];

  const onclick = (name, screen) => {
    RootNavigation.navigate(`Profile/${screen}`)
    setActiveScreen(screen);
  };

  useEffect(() => {
    let currentScreenPath = location?.pathname?.split("/")[2];
    setActiveScreen(currentScreenPath)
  }, [])

  return (
    <View style={styles.container}>
      <Header navigation={props?.navigation} />
      <MobileHeader isShowSidebar={setIsShowSidebar} isHeaderView  />
     <TabHeader />
      <View style={styles.contentWidget}>
        {!isShowSidebar && <Sidebar navigation={props?.navigation} />}
        <View style={styles.sideContentWidget}>
          <View style={styles.userDetailsWidget}>
            <UserDetails navigation={props?.navigation} />
          </View>

          <View style={styles.Profile_profileCardsHelper}>
            {profileTabs.map((item, index) => {
              return (
                <View style={styles.Profile_profileCards} key={index}>
                  <TouchableOpacity
                    onPress={() => onclick(item.name, item.route)}
                    key={index}
                    style={[styles.Profile_profileCardsItem,{backgroundColor:activeScreen == item.route ? "#ffffff" : "#c32b2c", }]} >
                    <Text style={[styles.cardTextStyle1,{ color: activeScreen == item.route ? "#66625f" : "#ffffff"} ]}>
                      {item.name}
                    </Text>
                    <Image source={ activeScreen == item.name ? item.activeIcon : item.icon }
                      style={[styles.iconStyle,{ height: item.height, width: item.width } ]}
                    />
                  </TouchableOpacity>
                </View>
              );
            })}
          </View>
          <Outlet />
        </View>
      </View>
      {showLogoutModal ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={"Error"}
            message={global.TimeoutError}
            actionButton={"OK"}
            onCloseModal={() => setIsLoggedIn(false)}
          />
        </View>
      ) : null}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
        width: "100%",
        height: '100vh',
        backgroundColor:'#f2f4f5',
        backgroundImage:
        "linear-gradient(to top, #f2f4f5, #f2f4f5 20%, #eee 20%, #333 20%);",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
      marginLeft: 20,
      alignItems: "center",
      justifyContent: "center",
    },
    Profile_profileCardsHelper: {
      paddingLeft: 20,
      marginHorizontal: -10,
      flexDirection: "row",
    },

    Profile_profileCards: {
      width: "20%",
    },

    Profile_profileCardsItemHelper: {
      width: "100%",
      flexDirection: "row",
    },
    contentWidget: {
      flexDirection: "row",
      maxWidth: 1200,
      alignSelf: "center",
      marginTop: 40,
      width: "100%",
    },
    sideContentWidget: {
      width: "90%",
    },
    userDetailsWidget: { marginLeft: 20 },
    Profile_profileCardsItem: {
      borderRadius: 12,
      flexGrow: 1,
      marginHorizontal: 10,
      flexDirection: "row",
      height: "73.3px",
      justifyContent: "space-between",
      alignItems: "center",
      paddingHorizontal: 20,
    },

    iconStyle: {
      width: 32,
      height: 28,
    },

    contentContainerStyle: {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "wrap",
      marginLeft: 10,
      overflowX: "hidden",
    },
    cardContainerStyle: {
      width: "100%",
      flex: 1,
      height: 73.3,
      borderRadius: 12,
      backgroundColor: "#c32b2c",
      flexDirection: "row",
      marginHorizontal: 9,
      paddingHorizontal: 20,
      marginTop: 30,
      alignItems: "center",
      minWidth: 175,
    },
    npciImageStyle: {
      width: 200.6,
      height: 45.1,
      marginTop: 20,
      marginLeft: "14%",
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.45,
      textAlign: "left",
      color: "#ffffff",
      paddingTop: 10,
    },
    cardTextStyle: {
      fontFamily: "Inter",
      fontSize: 28,
      fontWeight: "100",
      fontStyle: "normal",
      lineHeight: 19,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
      flexWrap: "wrap",
      alignSelf: "flex-start",
      position: "relative",
      top: -10,
    },
    cardTextStyle1: {
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0.65,
      textAlign: "left",
      color: "#ffffff",
      position: "relative",
    },

    userDetailsView: {
      display: "flex",
      marginLeft: 20,
    },
  },

  {
    [DEVICE_SIZES.LG]: {
      container: {
        width: "100%",
      },
      cardContainerStyle: {
        width: 188,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        height: 1700,
      },
      cardContainerStyle: {
        marginTop: 20,
        minWidth: "33vw",
        width: "100%",
        flexShrink: 0,
      },
      cardTextStyle: {
        fontSize: 25,
      },
      contentContainerStyle: {
        flexDirection: "row",
        width: "100%",
      },
      userDetailsView: {
        display: "none",
      },
      contentWidget: {
        maxWidth: 999,
        paddingLeft: 10,
      },
      sideContentWidget: {
        width: "80%",
      },
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      Profile_profileCardsHelper: {
        flexWrap: "wrap",
        height: 310,
        marginVertical: -10,
      },
      Profile_profileCards: {
        width: "50%",
        marginVertical: 10,
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      container: {
        width: "100%",
        marginLeft: 0,
      },

      Profile_profileCardsHelper: {
        height: 280,
      },
      Profile_profileCards: {
        width: "50%",
      },
      contentContainerStyle: { alignItems: "flex-start" },
      cardContainerStyle: {
        height: 53,
        marginTop: 10,
      },
      cardTextStyle1: { fontSize: 11 },
      iconStyle: {
        width: 25,
        height: 23,
      },
    },

    [DEVICE_SIZES.SM]: {
      cardContainerStyle: {
        minWidth: "30vw",
        width: "100%",
        flexShrink: 0,
      },
      cardTextStyle: {
        fontSize: 20,
      },
      contentContainerStyle: {
        flexDirection: "row",
        width: "100%",
      },
      userDetailsView: {
        display: "none",
      },
      userDetailsWidget: {
        display: "none",
      },
    },
    [DEVICE_SIZES.XS]: {
      cardContainerStyle: {
        minWidth: "40vw",
        width: "100%",
        flexShrink: 0,
      },
      contentWidget: {
        marginLeft: 25,
      },
      cardTextStyle: {
        fontSize: 20,
      },
      contentContainerStyle: {
        flexDirection: "row",
        width: "100%",
      },
      userDetailsView: {
        display: "none",
      },
      Profile_profileCardsHelper: {
        paddingLeft: 0,
      },
      userDetailsWidget: {
        display: "none",
      },
    },
  }
);
